import { ICompanyAnsweredQuestion, CompanyQuestionType } from '../../common';
import ViewAnswerHistory from '../../components/ToolsComponents/ViewAnswerHistory';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../base';
import { toolsActions, toolsSelectors } from '../../actions';
import { RoutePaths } from '../../routes/RoutePaths';
import { useNavigate } from 'react-router-dom';

const ToolsViewAnswersHistoryPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const companyId = useAppSelector(toolsSelectors.getActiveCompany);
    const questionsWithAnswers = useAppSelector(
        toolsSelectors.getActiveCompanyQuestionsHistory
    );

    const handleEdit = (answer: ICompanyAnsweredQuestion) => {
        dispatch(toolsActions.setActiveEditQuestionAnswer(answer));
        navigate(RoutePaths.companyDetails);
    };
    useEffect(() => {
        if (companyId) {
            dispatch(
                toolsActions.fetchCompanyQuestionsHistory({
                    companyId: companyId?.value || '',
                })
            );
        }
    }, [companyId, dispatch]);

    return (
        <ViewAnswerHistory
            questionsWithAnswers={questionsWithAnswers}
            onEdit={handleEdit}
        />
    );
};

export default ToolsViewAnswersHistoryPage;
